import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../../../components/form/form-field';
import SaveButton from '../../../../../components/form/save-button';
import { useNodeContext } from '../../../../../context/node-context';

const CopyFileToS3TaskForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id: _id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="copyFileToS3TaskFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="copyFileToS3TaskFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="copyFileToS3TaskFormFunction"
        label="function"
        name="function"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.function?.message}
        defaultValue="copyFileToS3"
      />
      <FormField
        controlId="copyFileToS3TaskFormCredentials"
        label="credentials"
        name="parameters.credentials"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter credentials"
        error={errors.parameters?.credentials?.message}
      />
      <FormField
        controlId="copyFileToS3TaskFormPort"
        label="port"
        name="parameters.port"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter port"
        error={errors.parameters?.port?.message}
      />
      <FormField
        controlId="copyFileToS3TaskFormSource"
        label="source"
        name="parameters.source"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter source path"
        required
        error={errors.parameters?.source?.message}
      />
      <FormField
        controlId="copyFileToS3TaskFormResult"
        label="result"
        name="parameters.result"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter result"
        required
        error={errors.parameters?.result?.message}
      />
      <FormField
        controlId="copyFileToS3TaskFormTargetS3Bucket"
        label="targetS3Bucket"
        name="parameters.targetS3Bucket"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter target S3 bucket"
        required
        error={errors.parameters?.targetS3Bucket?.message}
      />
      <FormField
        controlId="copyFileToS3TaskFormAwsAccessKeyId"
        label="awsAccessKeyId"
        name="parameters.awsAccessKeyId"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter AWS Access Key ID"
        required
        error={errors.parameters?.awsAccessKeyId?.message}
      />
      <FormField
        controlId="copyFileToS3TaskFormAwsSecretAccessKey"
        label="awsSecretAccessKey"
        name="parameters.awsSecretAccessKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter AWS Secret Access Key"
        required
        error={errors.parameters?.awsSecretAccessKey?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default CopyFileToS3TaskForm;
